import { render, staticRenderFns } from "./Affiliate-Header.vue?vue&type=template&id=74f26fc8"
import script from "./Affiliate-Header.vue?vue&type=script&lang=js"
export * from "./Affiliate-Header.vue?vue&type=script&lang=js"
import style0 from "./Affiliate-Header.vue?vue&type=style&index=0&id=74f26fc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports